import { LogoutRequest } from '@pages/logout/models/logout-request.interface';

const actionScope = '[Logout]';

export class OpenIdConnectLogOut {
  static readonly type = `${actionScope} Open Id Connect Log Out`;

  constructor(public logoutRequest: LogoutRequest) {}
}

export class OpenIdConnectLogOutCompleted {
  static readonly type = `${actionScope} Open Id Connect Log Out Completed`;
}

export class OpenIdConnectLogOutError {
  static readonly type = `${actionScope} Open Id Connect Log Out Error`;
}
